// extracted by mini-css-extract-plugin
export var deleteModal = "_ew-0";